import React from 'react'
import Text from '../Text'
import BottomSheet from './index'

const ReasonSheet = ({ show, onClose, reason }) => {
  return (
    <BottomSheet show={show} title="Reason" onClose={onClose}>
      <div className="p-4">
        <Text variant="body" size="medium" tag="p">
          {reason}
        </Text>
      </div>
    </BottomSheet>
  )
}

export default ReasonSheet
